import { render } from "./AgentView.vue?vue&type=template&id=4c618e56"
import script from "./AgentView.vue?vue&type=script&lang=js"
export * from "./AgentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__